import React, { Component } from 'react';

class Settings extends Component {
  render() {
    return (
      <div>
        <h1
          data-testid="settings-title"
        >
          Title
        </h1>
      </div>
    );
  }
}

export default Settings;
